// Leave Types
export const LEAVE_TYPES = {
  SICK_EMERGENCY: 'sick_emergency',
  PERSONAL: 'personal',
};

export const LEAVE_TYPE_LABELS = {
  [LEAVE_TYPES.SICK_EMERGENCY]: 'Sick/Emergency Leave',
  [LEAVE_TYPES.PERSONAL]: 'Personal Leave',
};

// Leave Status
export const LEAVE_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const LEAVE_STATUS_LABELS = {
  [LEAVE_STATUS.PENDING]: 'Pending',
  [LEAVE_STATUS.APPROVED]: 'Approved',
  [LEAVE_STATUS.REJECTED]: 'Rejected',
  [LEAVE_STATUS.CANCELLED]: 'Cancelled',
};

// Status Colors for badges
export const LEAVE_STATUS_COLORS = {
  [LEAVE_STATUS.PENDING]: 'warning',
  [LEAVE_STATUS.APPROVED]: 'success',
  [LEAVE_STATUS.REJECTED]: 'error',
  [LEAVE_STATUS.CANCELLED]: 'default',
};

// Half Day Types
export const HALF_DAY_TYPES = {
  FIRST_HALF: 'first_half',
  SECOND_HALF: 'second_half',
};

export const HALF_DAY_TYPE_LABELS = {
  [HALF_DAY_TYPES.FIRST_HALF]: 'First Half',
  [HALF_DAY_TYPES.SECOND_HALF]: 'Second Half',
};

// Initial form state
export const INITIAL_LEAVE_FORM_STATE = {
  leaveType: '',
  startDate: null,
  endDate: null,
  isHalfDay: false,
  halfDayType: '',
  reason: '',
  reviewers: [],
};

// Table columns
export const LEAVE_TABLE_COLUMNS = [
  { id: 'employee', label: 'Employee', alignRight: false },
  { id: 'leaveType', label: 'Leave Type', alignRight: false },
  { id: 'startDate', label: 'Start Date', alignRight: false },
  { id: 'endDate', label: 'End Date', alignRight: false },
  { id: 'totalDays', label: 'Days', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'actions', label: '', alignRight: true },
];


